import { lazyGetMoveToSections } from 'owa-mail-ribbon-sections/lib/sections';
import { lazyEnsureFocusedOverrideLoaded } from 'owa-mail-focused-inbox-override';
import { getSelectedTableView } from 'owa-mail-list-store';

import type { MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { MailboxInfo } from 'owa-client-types';

import { setMenuDefinition } from '../../mutatorActions/setMenuDefinition';

export const onMoveToMenuClicked = (
    keytipTabId: MailRibbonTabId | undefined,
    props: ReadOnlyRibbonControlDefProps,
    mailboxInfo: MailboxInfo
): void => {
    const projectionTabId = props.isPopout ? props.projectionTabId : undefined;

    // Lazily load the focused-override property for the selected row so
    // "Always move to Other" enables correctly. Fire-and-forget; MobX
    // re-renders the menu when the result lands.
    const tableView = getSelectedTableView();
    if (tableView) {
        const rowKey = props.selectedRowKey ?? [...tableView.selectedRowKeys.keys()][0];
        if (rowKey) {
            lazyEnsureFocusedOverrideLoaded.importAndExecute(rowKey, tableView);
        }
    }

    lazyGetMoveToSections.import().then(getMoveToSections => {
        setMenuDefinition('MoveToMenuDefinitionStore', projectionTabId, () => {
            return {
                sections: getMoveToSections(keytipTabId, props, mailboxInfo),
            };
        });
    });
};
